import { Route, Routes } from "react-router-dom";
import PainelTVScreen from "../components/Painel/PainelTVScreen";

import AtendimentoList from "../components/Atendimento/AtendimentoList";
import ClientesHistorico from "../components/Clientes/ClientesHistorico";
import ClientesList from "../components/Clientes/ClientesList";
import PrivacyPolicy from "../components/Common/PrivacyPolicy";
import TermsOfService from "../components/Common/TermsOfService";
import Dashboard from "../components/Dashboard/Dashboard";
import DevolucoesList from "../components/Devolucoes/DevolucoesList";
import NotFound from "../components/ErrorPages/NotFound";
import ServerError from "../components/ErrorPages/ServerError";
import FuncionariosList from "../components/Funcionarios/FuncionariosList";
import RelatorioFuncionarios from "../components/Relatorio/RelatorioFuncionarios";
import Layout from "../components/Layout/Layout";
import Perfil from "../components/Perfil/Perfil";
import ProdutosList from "../components/Produtos/ProdutosList";
import ReservasList from "../components/Reservas/ReservasList";
import Painel from "../components/Painel/Painel";

type PrivateRoutesProps = {
  onLogout: () => void;
};

export default function PrivateRoutes({ onLogout }: PrivateRoutesProps) {
  return (
    <>
      <Routes>
        <Route path="/painel-tv" element={<PainelTVScreen />} />
        <Route path="*" element={<Layout onLogout={onLogout}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/clientes" element={<ClientesList />} />
                <Route path="/clientes/historico" element={<ClientesHistorico />} />
                <Route path="/produtos" element={<ProdutosList />} />
                <Route path="/reservas" element={<ReservasList />} />
                <Route path="/devolucoes" element={<DevolucoesList />} />
                <Route path="/atendimento" element={<AtendimentoList />} />
                <Route path="/funcionarios" element={<FuncionariosList />} />
                <Route path="/relatorio-produtividade" element={<RelatorioFuncionarios />} />
                <Route path="/painel" element={<Painel />} />
                <Route path="/perfil" element={<Perfil />} />
                <Route path="/privacidade" element={<PrivacyPolicy />} />
                <Route path="/termos" element={<TermsOfService />} />
                <Route path="/404" element={<NotFound />} />
                <Route path="/500" element={<ServerError />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </>
  );
}
